// import React, { useState } from 'react';
// import { Form, Input, Button, Select, message } from 'antd';
// import axios from 'axios';
// import Cookies from 'js-cookie';

// const { Option } = Select;
// const API = process.env.REACT_APP_API_URL ;

// export default function ThemeEditor() {
//   const [loading, setLoading] = useState(false);

//  const onFinish = async (values) => {
//   if (!values.eventId) return message.error('Event ID is required');
//   setLoading(true);
  
//   try {
//     const form = new FormData();
    
//     // Use backend field names directly
//     const themeData = {
//       manu_color: values.primary || '',
//       manuhover_color: values.secondary || '',
//       manu_text_color: values.accent || '',
//       manu_text_hover_color: values.accent || '', // or separate value
//       button_color: values.buttonColor || '',
//       button_text_color: '#ffffff', // add this field to your form if needed
//       font_family: values.fontFamily || '',
//       layout_variant: values.layoutVariant || '',
//       theme_name: values.name || 'custom'
//     };

//     form.append('eventId', values.eventId);
//     form.append('manu_color', themeData.manu_color);
//     form.append('manuhover_color', themeData.manuhover_color);
//     form.append('manu_text_color', themeData.manu_text_color);
//     form.append('manu_text_hover_color', themeData.manu_text_hover_color);
//     form.append('button_color', themeData.button_color);
//     form.append('button_text_color', themeData.button_text_color);
//     form.append('font_family', themeData.font_family);
//     form.append('layout_variant', themeData.layout_variant);
//     form.append('theme_name', themeData.theme_name);

//     // Handle banner file
//     const bannerFile = document.__bannerFile || null;
//     if (bannerFile) {
//       form.append('banner', bannerFile);
//     }

//     const headers = {
//       Authorization: `Bearer ${Cookies.get('token')}`,
//     };

//     const resp = await axios.post(`${API}/api/admin/updateTheme`, form, { headers });
//     message.success('Theme updated');
//   } catch (err) {
//     console.error(err);
//     message.error('Failed to update theme');
//   } finally {
//     setLoading(false);
//   }
// };

//   const normFile = (e) => {
//     if (!e) return;
//     // antd Upload returns an object; we can accept native file input by using custom input
//     return e;
//   };

//   return (
//     <div style={{ maxWidth: 800, margin: '24px auto', background: '#fff', padding: 24 }}>
//       <h2>Theme Editor (Admin)</h2>
//       <Form layout="vertical" onFinish={onFinish}>
//         <Form.Item name="eventId" label="Event ID" rules={[{ required: true }]}> 
//           <Input placeholder="Event ID" />
//         </Form.Item>

//         <Form.Item name="name" label="Theme Name">
//           <Input placeholder="Theme name (optional)" />
//         </Form.Item>

//         <Form.Item name="primary" label="Primary Color">
//           <Input type="color" />
//         </Form.Item>

//         <Form.Item name="secondary" label="Secondary Color">
//           <Input type="color" />
//         </Form.Item>

//         <Form.Item name="accent" label="Accent Color">
//           <Input type="color" />
//         </Form.Item>

//         <Form.Item name="buttonColor" label="Button Color">
//           <Input type="color" />
//         </Form.Item>

//         <Form.Item name="fontFamily" label="Font Family">
//           <Select showSearch allowClear>
//             <Option value="Inter, sans-serif">Inter</Option>
//             <Option value="Roboto, sans-serif">Roboto</Option>
//             <Option value="Poppins, sans-serif">Poppins</Option>
//             <Option value="" >Default</Option>
//           </Select>
//         </Form.Item>

//         <Form.Item name="layoutVariant" label="Layout Variant">
//           <Select allowClear>
//             <Option value="default">Default</Option>
//             <Option value="hero">Hero</Option>
//             <Option value="compact">Compact</Option>
//           </Select>
//         </Form.Item>

//         <Form.Item label="Banner Image">
//           <input type="file" name="banner" onChange={(e) => (document.__bannerFile = e.target.files[0])} />
//         </Form.Item>

//         <Form.Item>
//           <Button type="primary" htmlType="submit" loading={loading} onClick={() => {
//             // collect banner file from document.__bannerFile and put into form values via hidden field
//             const formEl = document.querySelector('form');
//           }}>
//             Save Theme
//           </Button>
//         </Form.Item>
//       </Form>
//     </div>
//   );
// }


import {
  CCard,
  CCardBody,
  CCardTitle,
  CCardHeader,
  CForm,
  CButton,
  CFormInput,
  CCol,
} from '@coreui/react'
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { useForm } from 'react-hook-form'
import { useState, useEffect } from 'react'
import { getThemeApi, updateThemeApi } from '../../../redux/api/api'

const Theme = () => {
  const [theme, setTheme] = useState({})
  const [eventId, setEventId] = useState('')
  const [bannerFile, setBannerFile] = useState(null)
  const [isLoading, setIsLoading] = useState(false)
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    clearErrors,
    getValues,
    watch,
  } = useForm()

  const fetchTheme = async () => {
    try {
      const response = await getThemeApi()
      if (response.data.status === 200) {
        setTheme(response.data.info)
        const data = response.data.info
        setValue('manu_color', data.manu_color)
        setValue('manuhover_color', data.manuhover_color)
        setValue('manu_text_color', data.manu_text_color)
        setValue('manu_text_hover_color', data.manu_text_hover_color)
        setValue('button_color', data.button_color)
        setValue('button_text_color', data.button_text_color)
        setValue('manu_text_color', data.manu_text_color)
        // apply existing global theme to preview
        applyPreview({
          colors: { primary: data.manu_color, secondary: data.manuhover_color, accent: data.manu_text_color },
          buttonColor: data.button_color,
          buttonTextColor: data.button_text_color,
          fontFamily: data.font_family || '',
          bannerImage: data.bannerImage || '',
        })
      } else {
        toast.error('Error fetching theme')
      }
    } catch (error) {
      console.error('Error fetching theme:', error)
    }
  }

  useEffect(() => {
    fetchTheme()
  }, [])

  const onSubmit = async (data) => {
    setIsLoading(true)
    try {
      // If eventId provided, submit per-event theme; otherwise legacy global update
      if (eventId) {
        const themeObj = {
          name: data.theme_name || 'custom',
          fontFamily: data.font_family || '',
          layoutVariant: data.layout_variant || '',
          buttonColor: data.button_color || '',
          buttonTextColor: data.button_text_color || '',
          colors: {
            primary: data.manu_color || '',
            secondary: data.manuhover_color || '',
            accent: data.manu_text_color || '',
          },
        }

        const form = new FormData()
        form.append('eventId', eventId)
        form.append('theme', JSON.stringify(themeObj))
        if (bannerFile) form.append('banner', bannerFile)

        // include auth header by updateThemeApi? use axios directly to ensure header
        const token = localStorage.getItem('token') || ''
        const headers = {
          Authorization: token ? `Bearer ${token}` : '',
          'Content-Type': 'multipart/form-data',
        }

        const axios = require('axios')
        const API = process.env.REACT_APP_API_URL || ''
        const resp = await axios.post(`${API}/api/admin/theme/update`, form, { headers })
        if (resp.data?.status === 200) {
          toast.success('Event theme updated')
        } else {
          toast.error('Failed to update event theme')
        }
      } else {
        // legacy update
        const themeData = {
          manu_color: data.manu_color,
          manuhover_color: data.manuhover_color,
          manu_text_color: data.manu_text_color,
          manu_text_hover_color: data.manu_text_hover_color,
          button_color: data.button_color,
          button_text_color: data.button_text_color,
          manu_text_color: data.manu_text_color,
        }

        const response = await updateThemeApi(themeData)
        if (response.data.status === 200) {
          fetchTheme()
          toast.success('Theme updated successfully')
        } else {
          toast.error('Error updating theme')
        }
      }
    } catch (error) {
      console.error('Error updating theme:', error)
      toast.error('Error updating theme')
    } finally {
      setIsLoading(false)
    }
  }

  const applyPreview = (themeObj) => {
    if (!themeObj) return
    const root = document.documentElement
    const colors = themeObj.colors || {}
    if (colors.primary) root.style.setProperty('--primary-color', colors.primary)
    if (colors.secondary) root.style.setProperty('--secondary-color', colors.secondary)
    if (colors.accent) root.style.setProperty('--accent-color', colors.accent)
    if (themeObj.fontFamily) root.style.setProperty('--theme-font-family', themeObj.fontFamily)
    if (themeObj.buttonColor) root.style.setProperty('--button-color', themeObj.buttonColor)
    if (themeObj.buttonTextColor) root.style.setProperty('--button_text_color', themeObj.buttonTextColor || '#ffffff')
    if (themeObj.bannerImage) root.style.setProperty('--banner-image', `url(${themeObj.bannerImage})`)
    // legacy vars
    if (colors.primary) root.style.setProperty('--manu-color', colors.primary)
    if (colors.secondary) root.style.setProperty('--manuhover_color', colors.secondary)
    if (colors.accent) root.style.setProperty('--manu_text_color', colors.accent)
  }

  // watch form fields for live preview
  useEffect(() => {
    const subscription = watch((value) => {
      const preview = {
        colors: {
          primary: value.manu_color || '',
          secondary: value.manuhover_color || '',
          accent: value.manu_text_color || '',
        },
        buttonColor: value.button_color || '',
        buttonTextColor: value.button_text_color || '',
        fontFamily: value.font_family || '',
      }
      applyPreview(preview)
    })
    return () => subscription.unsubscribe()
  }, [watch])

  return (
    <>
      <ToastContainer />
      <CCard>
        <CCardHeader>
          <CCardTitle>Admin Theme</CCardTitle>
        </CCardHeader>
        <CCardBody>
          <CForm
            className="row g-3"
            onSubmit={handleSubmit(onSubmit)}
            encType="multipart/form-data"
          >
            <CCol xl={6} md={12}>
              <CFormInput
                style={{ width: '100%' }}
                type="color"
                value={watch('manu_color')}
                label="Menu Color"
                {...register('manu_color')}
              />
            </CCol>
            <CCol xl={6} md={12}>
              <CFormInput
                style={{ width: '100%' }}
                type="color"
                value={watch('manuhover_color')}
                label="Menu Hover Color"
                {...register('manuhover_color')}
              />
            </CCol>
            <CCol xl={6} md={12}>
              <CFormInput
                style={{ width: '100%' }}
                type="color"
                value={watch('manu_text_color')}
                label="Menu Text Color"
                {...register('manu_text_color')}
              />
            </CCol>
            <CCol xl={6} md={12}>
              <CFormInput
                style={{ width: '100%' }}
                type="color"
                value={watch('manu_text_hover_color')}
                label="Menu Text Hover Color"
                {...register('manu_text_hover_color')}
              />
            </CCol>
            <CCol xl={6} md={12}>
              <CFormInput
                style={{ width: '100%' }}
                type="color"
                value={watch('button_color')}
                label="Button Color"
                {...register('button_color')}
              />
            </CCol>
            <CCol xl={6} md={12}>
              <CFormInput
                style={{ width: '100%' }}
                type="color"
                value={watch('button_text_color')}
                label="Button Text Color"
                {...register('button_text_color')}
              />
            </CCol>
            <CCol xl={12} md={12} className="mb-3">
              <label>Event ID (leave empty to update global admin theme)</label>
              <CFormInput
                style={{ width: '100%' }}
                value={eventId}
                onChange={(e) => setEventId(e.target.value)}
                placeholder="Enter Event ID for per-event theme"
              />
            </CCol>

            <CCol xl={12} md={12} className="mb-3">
              <label>Banner Image (optional)</label>
              <input type="file" name="banner" accept="image/*" onChange={(e) => setBannerFile(e.target.files[0] || null)} />
            </CCol>

            <CCol xl={12} md={12} className="text-center">
              <CButton type="submit" className="btnsubmit" disabled={isLoading}>
                {isLoading ? 'Saving...' : 'Save'}
              </CButton>
            </CCol>
          </CForm>
        </CCardBody>
      </CCard>
    </>
  )
}
export default Theme

